import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@mui/material/TextField';
import ArchiveIcon from '@mui/icons-material/Archive';
import SaveIcon from '@mui/icons-material/Save';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import util from 'library/util';
import WithRouter from 'custom/withRouter';
import { initializePurchaseOrderForm } from 'actions/FormActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { getCsvReport } from 'actions/ReportsAction';
import { poEditCrumb, poAddCrumb, poReportEditCrumb } from 'utils/breadcrumbInfo';
import { toMoney, toMoneyTyping } from 'library/moneyUtils';
import {
    getPurchaseOrder, savePurchaseOrder, removePOProduct, updateUnitPriceDatabase,
    openPurchaseOrder, cancelPurchaseOrder, onOrderPurchaseOrder, getTaxesRate, getVendorsByCountryState, unreceivePOProduct,
    clearProductList, unreceiveAll
} from 'actions/EntityActions';
import LOOKUP from 'constants/lookup';
import { selectPurchaseOrderModel } from 'selectors/entitySelector';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import DialogAlert from 'screens/components/basic/DialogAlert';
import RadioInput from 'screens/components/basic/RadioInput';
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInputNew from 'screens/components/advanced/DialogInputNew';
import DecimalInput from 'screens/components/basic/DecimalInput';
import CardSimple from 'screens/components/basic/CardSimple';
import DialogHeader from 'screens/components/basic/DialogHeader';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import PageHeader from 'screens/components/basic/PageHeader';

import VendorSave from '../vendor/VendorSave';
import ProductSave from '../product/ProductSave';
import POProductSave from './POProductSave';
import POPrintToPDF from './components/POPrintToPDF';
//CSS
import 'styles/po.css';

const customContentStyle = {
    width: '95%',
    maxWidth: 'none'
};

class PurchaseOrderSave extends Component {

    constructor(props) {
        super(props);

        this.statusOpened = 'Opened';
        this.statusOnOrder = 'On Order';
        this.statusCancelled = 'Cancelled';
        this.statusClosed = 'Closed';

        this.state = {
            status: null,
            addItemOpen: true,
            vendorDialogOpen: false,
            productDialogOpen: false,
            removeProductDialogOpen: false,
            updateUnitPriceDialogOpen: false,
            unreceiveProductDialogOpen: false,
            productIndexToRemove: -1,
            productUnitPriceUpdate: {},
            productUnreceive: null,
            subtotal: 0,
            total: 0,
            taxesProvince: null,
            unitPrice: 0.00,
            activePage: 1,
            itemsPerPage: 10,
            unreceiveAllProductsOpen: false,
            productPriceUpdateNotes: ""
        };
    }

    componentWillMount() {
        this.props.getVendors(this.props.store.country, this.props.store.provinceState);
        this.props.getTaxesRate(this.props.branchId);
        const purchaseOrderId = this.props.params.id;
        const branchId = this.props.params.branchId != null ? this.props.params.branchId : this.props.branchId;
        //if true dispatch an action to retrive patient data from API and set Status to EDIT
        if (purchaseOrderId) {
            this.setState({ status: "EDIT", addItemOpen: false });
            this.props.getPurchaseOrder(purchaseOrderId, branchId);
        }
        //if false dispatch an action to clean the form and set default values, Status to ADD
        else {
            this.setState({ status: "ADD" });
            this.props.init(this.props.name);
        }
        if (this.props.newVendorId != null) {
            let newVendorState = this.props.vendors.filter(item => item.id == this.props.newVendorId)[0].state;
            this.setState({ taxesProvince: LOOKUP.taxesByProvince.filter(item => item.province == newVendorState || item.name == newVendorState) !== null ? LOOKUP.taxesByProvince.filter(item => item.province == newVendorState || item.name == newVendorState)[0] : null });
        } else {
            this.setState({ taxesProvince: LOOKUP.taxesByProvince.filter(item => item.province == this.props.store.provinceState || item.name == this.props.store.provinceState) !== null ? LOOKUP.taxesByProvince.filter(item => item.province == this.props.store.provinceState || item.name == this.props.store.provinceState)[0] : null });
        }

    }

    //check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        // check if PO was saved successfully
        if (newProps.saveSuccess !== this.props.saveSuccess) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else if (newProps.saveSuccess === false)
                this.saveFailure();
        }

        // check if the status of the PO was changed (open or cancel)
        if (newProps.purchaseOrderModel && newProps.purchaseOrderModel.Status
            && newProps.purchaseOrderModel.Id !== 0 && this.props.purchaseOrderModel.Status
            && newProps.purchaseOrderModel.Status !== this.props.purchaseOrderModel.Status) {
            if (newProps.purchaseOrderModel.Status === this.statusOpened) {
                this.props.openPurchaseOrder(newProps.purchaseOrderModel.Id, LOOKUP.purchaseOrder.openedMessage);
            }
            else if (newProps.purchaseOrderModel.Status === this.statusOnOrder) {
                this.props.onOrderPurchaseOrder(newProps.purchaseOrderModel.Id, LOOKUP.purchaseOrder.onOrderMessage);
            }
            else if (newProps.purchaseOrderModel.Status === this.statusCancelled) {
                this.props.cancelPurchaseOrder(newProps.purchaseOrderModel.Id, LOOKUP.purchaseOrder.cancelledMessage);
            }
        }

        // check if there was any errors when changing the status

        if (newProps.updateStatusSuccess !== this.props.updateStatusSuccess) {
            if (newProps.updateStatusSuccess === false) {
                this.props.showErrorStatus(LOOKUP.purchaseOrder.saveStatusErrorMessage);
            }
        }

        if (newProps.newVendorId !== null && newProps.newVendorId !== this.props.newVendorId) {
            let newVendorState = newProps.vendors.filter(item => item.id == newProps.newVendorId)[0].state;
            this.setState({ taxesProvince: LOOKUP.taxesByProvince.filter(item => item.province == newVendorState || item.name == newVendorState) !== null ? LOOKUP.taxesByProvince.filter(item => item.province == newVendorState || item.name == newVendorState)[0] : null });
        }

        //Calculating the totals
        if (newProps.purchaseOrderModel !== null) {
            if (newProps.purchaseOrderModel.Products !== null) {
                newProps.purchaseOrderModel.SubTotal = this.calculateSubTotal(newProps.purchaseOrderModel.Products);
                newProps.purchaseOrderModel.Taxes = this.organizeTaxes(newProps.purchaseOrderModel);
                newProps.purchaseOrderModel.Total = this.calculateTotal(newProps.purchaseOrderModel);
            }
        }

        if (newProps.store.provinceState != this.props.store.provinceState && newProps.store.provinceState != undefined && newProps.store.provinceState != "" && newProps.store.provinceState != null && this.props.newVendorId != null) {
            let newVendorState = this.props.vendors.filter(item => item.id == this.props.newVendorId)[0].state;
            this.setState({ taxesProvince: LOOKUP.taxesByProvince.filter(item => item.province == newVendorState || item.name == newVendorState) !== null ? LOOKUP.taxesByProvince.filter(item => item.province == newVendorState || item.name == newVendorState)[0] : null });
        } else {
            this.setState({ taxesProvince: LOOKUP.taxesByProvince.filter(item => item.province == newProps.store.provinceState || item.name == newProps.store.provinceState) !== null ? LOOKUP.taxesByProvince.filter(item => item.province == newProps.store.provinceState || item.name == newProps.store.provinceState)[0] : null });
        }

        if (newProps.unreceiveAllSuccess && newProps.unreceiveAllSuccess != this.props.unreceiveAllSuccess) {
            const purchaseOrderId = this.props.params.id;
            const branchId = this.props.params.branchId != null ? this.props.params.branchId : this.props.branchId;
            this.props.getPurchaseOrder(purchaseOrderId, branchId);
            this.props.showSnackbar('Unreceive all products success!');
        }
    }

    componentWillUnmount() {
        this.props.clearProductList();
    }

    onChange = (event) => {
        const value = event.target.value;
        const maskedStringValue = toMoneyTyping(value);
        const floatValue = parseFloat(maskedStringValue.replace(new RegExp(',', 'g'), ''));//.replace(',', ''));
        const min = parseFloat(0);
        const max = parseFloat(10000);
        let finalFloatValue = floatValue;

        if (this.props.min !== undefined && floatValue <= min) {
            finalFloatValue = min
        }
        if (this.props.max !== undefined && floatValue >= max) {
            finalFloatValue = max;
        }

        const finalMaskedStringValue = toMoneyTyping(Math.round(finalFloatValue * 100 * 100) / 100);

        this.setState({ unitPrice: finalMaskedStringValue });
    }

    onChangeNotes = (event) => {
        this.setState({ productPriceUpdateNotes: event.target.value })
    }

    calculateSubTotal(products) {
        let total = 0;
        products.map((product) => {
            total += parseFloat(product.Price);
        });

        return total;
    }

    organizeTaxes(po) {
        let taxes = [];

        (this.props.taxRates).map(t => {
            taxes.push({
                Amount: (t.name === 'GST') ? po.GST : (t.name === 'HST') ? po.HST : (t.name === 'QST') ? po.QST : po.PST,
                Id: t.id
            });
        });

        return taxes;
    }

    calculateTotal(po) {
        return parseFloat(parseFloat(po.GST) + parseFloat(po.HST) + parseFloat(po.PST) + parseFloat(po.QST) + parseFloat(po.SubTotal) + parseFloat(po.DeliveryFee) + parseFloat(po.TotalDepositAmount) + parseFloat(po.RecycleFee) - parseFloat(po.Credits)).toFixed(2);
    }

    //when Patient is saved successfully
    saveSuccess = () => {
        this.props.callListView();
        this.props.showSnackbar(this.state.status === "EDIT" ? LOOKUP.purchaseOrder.editedMessage : LOOKUP.purchaseOrder.createdMessage);
    }

    //when Patient is not saved, failure
    saveFailure = () => {
        this.props.showError(LOOKUP.purchaseOrder.saveErrorMessage);
    }

    statusDialogClosed = () => {
        window.location.reload();
    }

    openAddNewItem = () => {
        this.setState({ addItemOpen: true });
    }

    closeAddNewItem = () => {
        this.setState({ addItemOpen: false });
    }

    openVendorForm = () => {
        this.setState({ vendorDialogOpen: true });
    }

    closeVendorForm = () => {
        this.setState({ vendorDialogOpen: false });
        this.props.getVendors(this.props.store.country, this.props.store.provinceState);
    };

    openProductForm = () => {
        this.setState({ productDialogOpen: true });
    };
    closeProductForm = () => {
        this.setState({ productDialogOpen: false });
    };

    openDialogRemoveProduct = (index) => {
        this.setState({ removeProductDialogOpen: true, productIndexToRemove: index });
    };

    closeDialogRemoveProduct = () => {
        this.setState({ removeProductDialogOpen: false, productIndexToRemove: -1 });
    };

    closeDialogUnreceiveProduct = () => {
        this.setState({ unreceiveProductDialogOpen: false, productUnreceive: null });
    };

    openDialogUpdateUnitPriceProduct = (product) => {
        this.setState({ updateUnitPriceDialogOpen: true, productUnitPriceUpdate: product, unitPrice: product.unitPrice.toFixed(2), productPriceUpdateNotes: product.notes });
    };

    openDialogUnreceiveProduct = (product) => {
        this.setState({ unreceiveProductDialogOpen: true, productUnreceive: product });
    };

    closeDialogUpdateUnitPriceProduct = () => {
        this.setState({ updateUnitPriceDialogOpen: false, unitPrice: 0, productUnitPriceUpdate: null, productPriceUpdateNotes: "" });
        this.setState({ productUnitPriceUpdate: { product: "", sku: "", type: "", category: "", packageReference: "" } });
    };

    deleteProduct = () => {
        this.props.removePOProduct(this.state.productIndexToRemove);
        this.setState({ removeProductDialogOpen: false, productIndexToRemove: -1 });
    }

    unreceiveProduct = () => {
        this.props.unreceiveProduct(this.state.productUnreceive);
        this.setState({ unreceiveProductDialogOpen: false, productIndexToRemove: -1 });
    }

    unreceiveAllProducts = () => {
        let poId = this.props.purchaseOrderModel.Id;
        this.props.unreceiveAll(poId);
        this.closeUnreiveAllDialog();
    }

    updateUnitPriceForProduct = () => {
        this.props.updateUnitPriceDatabase({
            POId: this.state.productUnitPriceUpdate.purchaseOrderId, productId: this.state.productUnitPriceUpdate.productId, POproductId: this.state.productUnitPriceUpdate.id,
            unitPrice: this.state.unitPrice, branchId: this.props.branchId, packageReference: this.state.productUnitPriceUpdate.packageReference, status: this.state.productUnitPriceUpdate.status,
            notes: this.state.productPriceUpdateNotes
        });

        this.setState({ updateUnitPriceDialogOpen: false, productUnitPriceUpdate: null });
        this.setState({ productUnitPriceUpdate: { product: "", sku: "", type: "", category: "", packageReference: "" } });
    }

    unreceiveProduct = () => {
        this.props.unreceiveProduct({
            Id: this.state.productUnreceive.id, productId: this.state.productUnreceive.productId, branchId: this.props.branchId, packageReference: this.state.productUnreceive.packageReference,
            purchaseOrderId: this.state.productUnreceive.purchaseOrderId
        });
        this.setState({ unreceiveProductDialogOpen: false, productUnreceive: null });
    }

    loadProductList = (products, isDisabled) => {
        const list = [];
        products && products.map((product, index) => {
            const status = product.status;
            list.push(
                {
                    SKU: (
                        <div className="row m-0 pb-2 pt-2 col-4-p-0">
                            <div className="row">
                                <div className="col-lg-3 col-md-3 col-sm-3 col-3-p col-xs-12 PO_info">
                                    <h3 className="m-0"><b>{product.product}</b></h3>
                                    <p className="m-0 font-weight-normal">SKU: {product.sku}</p>
                                    <p className="font-weight-normal">Category: {`[${product.type}] ${product.category}`} </p>
                                    {
                                        product.packageReference && (
                                            <p className="font-weight-normal">Lot Number: {product.packageReference} </p>
                                        )
                                    }
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12 text-right">
                                    <div className="row m-0 PO_item">
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 m-0 p-0">
                                            <label>Ordered Qty</label>
                                            <h3 className="p-0 m-0">{`${product.quantity ? product.quantity : '0'}`}</h3>
                                            <p>{`${product.isUnitProduct ? 'unit(s)' : 'g'}`}</p>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 m-0 p-0">
                                            <label>Current Qty</label>
                                            <h3 className="p-0 m-0">{`${product.actualQuantity ? product.actualQuantity : '0'}`}</h3>
                                            <p>{`${product.isUnitProduct ? 'unit(s)' : 'g'}`}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <div className="row m-0 PO_item">
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 m-0 p-0">
                                            <label>Unit Price</label>
                                            <p>{"$" + Number(product.unitPrice).toFixed(2)}</p>
                                            <p>Change Unit Price</p>
                                            {product.status ? <Button style={{ marginTop: -20 }} type="IconEditButton"
                                                mini={true}
                                                onTouchTap={() => this.openDialogUpdateUnitPriceProduct(product)} /> : ""}
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 m-0 p-0">
                                            <label>Total</label>
                                            <p>{"$" + product.price.toFixed(2)}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12 PO_btn mb_xs p-0">
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 m-0 p-0">
                                        <label>Delete Product</label>
                                        <Button type="IconDeleteButton"
                                            primary={true}
                                            className="IconDeleteButton"
                                            disabled={status === 'Closed' || isDisabled ? true : false}
                                            onTouchTap={() => this.openDialogRemoveProduct(index)} />
                                    </div>
                                    {
                                        product.canUnreceive ?
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 m-0 p-0">
                                                <label>Un-Receive</label>
                                                <Button type="IconButton"
                                                    primary={true}
                                                    id={`unreceiveProduct-${index}`}
                                                    className="glyphicon glyphicon-open"
                                                    icon={<FileUploadIcon />}
                                                    onTouchTap={() => this.openDialogUnreceiveProduct(product)}
                                                    disabled={this.props.isHighTide}
                                                />
                                            </div>
                                            : ''
                                    }
                                </div>
                            </div>
                        </div>
                    ),
                    Name: product.product,
                    Type: product.type,
                    Category: product.category,
                    Quantity: product.quantity,
                    ActualQuantity: product.actualQuantity,
                    UnitPrice: "$" + product.unitPrice.toFixed(2),
                    Price: "$" + product.price,
                    Delete: <Button type="cancelButton"
                        label={LOOKUP.purchaseOrder.controls.removeProduct}
                        primary={true}
                        disabled={status === 'Closed' || isDisabled ? true : false}
                        onTouchTap={() => this.openDialogRemoveProduct(index)}
                    />
                });
        });

        const firstItemIndex = (this.state.activePage - 1) * this.state.itemsPerPage;
        const lastItemIndex = firstItemIndex + this.state.itemsPerPage

        return list.slice(firstItemIndex, lastItemIndex);
    };

    addPurchaseOrder = () => {
        let purchaseOrder = this.props.purchaseOrderModel;
        const purchaseOrderId = this.props.params.id;
        purchaseOrder.Id = parseInt(purchaseOrderId) || 0;
        const p = this.props;
        const validators = [
            [p.name + 'Name', purchaseOrder => (purchaseOrder.Description !== null && purchaseOrder.Description !== ""), "Description"],
            [p.name + 'VendorID', purchaseOrder => (purchaseOrder.VendorID !== undefined && purchaseOrder.VendorID !== null && purchaseOrder.VendorID !== ""), 'Vendor'],
            [p.name + 'PaymentDueDate', purchaseOrder => (purchaseOrder.PaymentDueDate !== null), "Payment Due Date"],
            [p.name + 'DateExpected', purchaseOrder => (purchaseOrder.DateExpected !== null), "Date Expected"]
        ];

        if (util.validate(validators, purchaseOrder, this.props.formError)) {
            this.props.savePurchaseOrder(purchaseOrder);
        }
    }

    loadVendorOptions = (vendors) => {
        let options = [];
        vendors.map((vendor) => {
            if (vendor.status === 'Active') {
                options.push(
                    { text: vendor.name, value: parseInt(vendor.id) }
                );
            }
        });
        return options;
    }

    changePage = e => {
        const isEdit = this.state.status == 'EDIT';
        const p = this.props;
        const isOpen = p.purchaseOrderModel.Status && (p.purchaseOrderModel.Status === this.statusOpened || p.purchaseOrderModel.Status === this.statusOnOrder);
        const isCancelled = p.purchaseOrderModel.Status && p.purchaseOrderModel.Status === this.statusCancelled;
        const isClosed = p.purchaseOrderModel.Status && p.purchaseOrderModel.Status === this.statusClosed;
        const isDisabled = isEdit && (isCancelled || isClosed);

        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, () => this.loadProductList(this.props.productsFromPO || [], isDisabled));
    }

    downloadCsv = () => {
        let POID = this.props.purchaseOrderModel.Id;

        this.props.getCsvReport(`purchaseorders/downloadcsv?poId=${POID}`, `purchaseOrder${POID}`);
    }

    saveToPDF = () => {
        document.getElementById('to-print').innerHTML = document.getElementById('po-save').innerHTML;

        // Hide Live Chat icon when printing
        document.getElementById('hubspot-messages-iframe-container').style.opacity = "0";
        setTimeout(function () {
            document.getElementById("hubspot-messages-iframe-container").style.opacity = "1";
        }, 500);

        window.print()
    }

    //Cancel the Save form, call the parent cancel function (redirect to listing)
    cancel = () => {
        this.props.navigate("/purchaseorder");
    };

    openUnreiveAllDialog = () => {
        this.setState({ unreceiveAllProductsOpen: true });
    }

    closeUnreiveAllDialog = () => {
        this.setState({ unreceiveAllProductsOpen: false });
    };

    render() {
        let p = this.props;
        let s = this.state;
        let isEdit = s.status == 'EDIT';
        let isOpen = p.purchaseOrderModel.Status && (p.purchaseOrderModel.Status === this.statusOpened || p.purchaseOrderModel.Status === this.statusOnOrder);
        let isCancelled = p.purchaseOrderModel.Status && p.purchaseOrderModel.Status === this.statusCancelled;
        let isClosed = p.purchaseOrderModel.Status && p.purchaseOrderModel.Status === this.statusClosed;
        let isDisabled = isEdit && (isCancelled || isClosed);
        let breadCrumbPage =
            this.state.status === 'EDIT'
                ? this.props.params.branchId != null
                    ? poReportEditCrumb
                    : poEditCrumb
                : poAddCrumb;

        let po = p.purchaseOrderModel ? p.purchaseOrderModel : null;

        let title = isEdit ? LOOKUP.purchaseOrder.titles.edit : LOOKUP.purchaseOrder.titles.add;

        let statuses = [{
            text: this.statusOpened,
            value: this.statusOpened//1
        },
        {
            text: this.statusOnOrder,
            value: this.statusOnOrder//1
        },
        {
            text: this.statusCancelled,
            value: this.statusCancelled//4
        }];

        return (
            <Grid headerContent={breadCrumbPage}>
                <PageHeader title={title} />
                <CardSimple title="General" className="p-1">
                    {
                        isEdit && (isOpen || isCancelled) ? (
                            <div className="row">
                                <div className="col-lg-4">
                                    <TextInput name={`${p.name}Name`}
                                        floatingLabelText={LOOKUP.purchaseOrder.name.label}
                                        hintText={LOOKUP.purchaseOrder.name.hintText}
                                        disabled={isDisabled}
                                        fullWidth={true} />
                                </div>
                                <div className="col-lg-3">
                                    <TextInput name={`${p.name}SupplierInvoiceNumber`}
                                        floatingLabelText={LOOKUP.purchaseOrder.supplierInvoiceNumber.label}
                                        hintText={LOOKUP.purchaseOrder.supplierInvoiceNumber.hintText}
                                        fullWidth={true} />
                                </div>
                                {
                                    (this.props.canChangePOStatus || (!this.props.isHighTide && !this.props.isInspired)) &&
                                    <div className="col-lg-5">
                                        <RadioInput
                                            groupName={`${p.name}Status`}
                                            title="Status"
                                            options={statuses}
                                            disabled={isDisabled}
                                            fullWidth={true} />
                                        {
                                            this.props.poSaveStatus === 'Opened' &&
                                            <p className='purpleText'><b>This order is in Open Status. To enable Receiving change the status to On Order.</b></p>
                                        }
                                        {
                                            this.props.poSaveStatus === 'On Order' &&
                                            <p className='purpleText'><b>This order is On Order Status. Receiving is now enabled.</b></p>
                                        }
                                    </div>
                                }
                            </div>)
                            : (
                                <div className="row">
                                    <div className="col-lg-8">
                                        <TextInput name={`${p.name}Name`}
                                            floatingLabelText={LOOKUP.purchaseOrder.name.label}
                                            hintText={LOOKUP.purchaseOrder.name.hintText}
                                            fullWidth={true} />
                                    </div>
                                    <div className="col-lg-4">
                                        <TextInput name={`${p.name}SupplierInvoiceNumber`}
                                            floatingLabelText={LOOKUP.purchaseOrder.supplierInvoiceNumber.label}
                                            hintText={LOOKUP.purchaseOrder.supplierInvoiceNumber.hintText}
                                            fullWidth={true} />
                                    </div>
                                </div>
                            )
                    }
                    <div className="row">
                        <div className="col-lg-4">
                            <SelectInput
                                name={`${p.name}VendorID`}
                                options={this.loadVendorOptions(p.vendors || [])}
                                floatingLabelText={'Vendor'}
                                hintText={'Vendor'}
                                disabled={isDisabled}
                                id="vendorDropdown"
                                required
                            />
                            <button className="link-new-above float-R"
                                onClick={() => this.openVendorForm()}>Create new Vendor</button>
                        </div>
                        <div className="col-lg-4" id="paymentDueDate">
                            <DatePickerInput
                                name={`${p.name}PaymentDueDate`}
                                hintText={LOOKUP.purchaseOrder.paymentDate.label}
                                floatingLabelText={LOOKUP.purchaseOrder.paymentDate.label}
                                required
                            />
                        </div>
                        <div className="col-lg-4" id="dateExpected">
                            <DatePickerInput
                                name={`${p.name}DateExpected`}
                                hintText={LOOKUP.purchaseOrder.dateExpected.label}
                                floatingLabelText={LOOKUP.purchaseOrder.dateExpected.label}
                                required
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4">
                            <DecimalInput
                                name={`${p.name}DeliveryFee`}
                                fullWidth={true}
                                label={"Shipping"}
                                hintText={"Shipping"}
                                floatingLabelText={"Shipping"}
                                min={0}
                                max={100000} />
                        </div>
                        <div className="col-lg-4">
                            <DecimalInput
                                name={`${p.name}RecycleFee`}
                                fullWidth={true}
                                label={"Recycle Fee"}
                                hintText={"Recycle Fee"}
                                floatingLabelText={"Recycle Fee"}
                                min={0}
                                max={100000} />
                        </div>
                        <div className="col-lg-4">
                            <DecimalInput
                                name={`${p.name}TotalDepositAmount`}
                                fullWidth={true}
                                label={"Deposit Amount"}
                                hintText={"Deposit Amount"}
                                floatingLabelText={"Deposit Amount"}
                                min={0}
                                max={100000} />
                        </div>
                        <div className="col-lg-4">
                            <DecimalInput
                                name={`${p.name}Credits`}
                                fullWidth={true}
                                label={"Credits"}
                                hintText={"Credits"}
                                floatingLabelText={"Credits"}
                                min={0}
                                max={100000} />
                        </div>
                        {
                            this.state.taxesProvince && this.state.taxesProvince.taxes ?
                                this.state.taxesProvince.taxes.map((tax, index) => {
                                    return (
                                        <div className="col-lg-4" key={index}>
                                            <DecimalInput
                                                name={`${p.name + tax}`}
                                                fullWidth={true}
                                                label={tax}
                                                hintText={tax}
                                                floatingLabelText={tax}
                                                min={0}
                                                max={100000} />
                                        </div>
                                    );
                                })
                                : ''
                        }
                    </div>
                </CardSimple>
                <br />
                <div className="row">
                    {
                        !s.addItemOpen ? (
                            <div className="row mb-2">
                                <div className="col-xs-6 col-lg-9 p-0 d-flex a-items">
                                    <div className="mr-2">({this.props.productsFromPO.length} items)</div>
                                    <Button
                                        type="AddButton"
                                        label="Add Item"
                                        id="addItem"
                                        className="mr-2"
                                        disabled={isDisabled}
                                        primary={true}
                                        onTouchTap={this.openAddNewItem} />
                                    <Button
                                        className="bg-light-green mr-2"
                                        type="IconInButton"
                                        id="exportToCSV"
                                        label={"Export to CSV"}
                                        icon={<ArchiveIcon />}
                                        onTouchTap={this.downloadCsv}
                                    />
                                    <Button
                                        className="bg-light-blue  mr-2"
                                        type="IconInButton"
                                        id="exportToPDF"
                                        label={"Export to PDF"}
                                        icon={<SaveIcon />}
                                        onTouchTap={this.saveToPDF}
                                    />
                                    <Button
                                        type="IconDeleteButton"
                                        className="pull-left"
                                        id="unreceiveAll"
                                        label="Unreceive All"
                                        primary={true}
                                        onTouchTap={this.openUnreiveAllDialog}
                                        disabled={this.props.isHighTide}
                                    />
                                </div>

                                {/*PO BUTTONS*/}
                                <div className="col-xs-6 col-lg-3 p-0">
                                    <Button name="placeOrderButton"
                                        className="pull-right btnNewBrandPOS"
                                        label="Save"
                                        primary={true}
                                        onTouchTap={this.addPurchaseOrder} />
                                    <Button
                                        type="CancelButton"
                                        name="buttonCancel"
                                        className="pull-right btn-space btnCancelOperation"
                                        label={LOOKUP.common.cancel.text}
                                        onTouchTap={() => this.cancel()} />
                                </div>
                            </div>)
                            : (
                                <CardSimple title="Product Detail" className="p-1">
                                    <POProductSave
                                        name="productPO"
                                        callListView={this.closeAddNewItem}
                                        cancelAddProduct={this.closeAddNewItem}
                                        openProductForm={this.openProductForm} />
                                </CardSimple>
                            )
                    }
                </div>
                {
                    !s.addItemOpen ?
                        (
                            <div>
                                {/*ITEMS TABLE*/}
                                <CardSimple>
                                    <div className="row">
                                        <div className="col-xs-12 col-md-9 p-0">
                                            <GenericTable
                                                columns={LOOKUP.purchaseOrder.tableColumnsProduct}
                                                rows={this.loadProductList(this.props.productsFromPO || [], isDisabled)}
                                                displaySelectAll={false}
                                                adjustForCheckbox={false}
                                                displayRowCheckbox={false}
                                                multiSelectable={false}
                                                enableSelectAll={false}
                                                fixedHeight={false}
                                                selectable={false}
                                                stripedRows={true}
                                            />
                                            <Pagination
                                                length={this.props.productsFromPO.length || 0}
                                                itemsPerPage={this.state.itemsPerPage}
                                                activePage={this.state.activePage}
                                                onPageChange={this.changePage}
                                                maxButtons={8}
                                            />
                                        </div>
                                        {/* Delivery info, tax and Total
                                        <div className="row m-0 div_right">*/}
                                        <div className="col-xs-12 col-md-3">
                                            {po.SubTotal > 0 ?
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div className="label-price">
                                                        <strong>
                                                            Subtotal
                                                            <div className="pull-right">
                                                                ${po ? po.SubTotal ? parseFloat(po.SubTotal).toFixed(2) : null : null}
                                                            </div>
                                                        </strong>
                                                    </div>
                                                </div>
                                                : ""
                                            }

                                            {po.DeliveryFee > 0 ?
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div className="label-price">
                                                        Shipping
                                                        <div className="pull-right">
                                                            ${po.DeliveryFee}
                                                        </div>
                                                    </div>
                                                </div>
                                                : ""
                                            }

                                            {po.RecycleFee > 0 ?
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div className="label-price">
                                                        Recycle Fee
                                                        <div className="pull-right">
                                                            ${po.RecycleFee}
                                                        </div>
                                                    </div>
                                                </div>
                                                : ""
                                            }
                                            {po.TotalDepositAmount > 0 ?
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div className="label-price">
                                                        Deposit Amount
                                                        <div className="pull-right">
                                                            ${po.TotalDepositAmount}
                                                        </div>
                                                    </div>
                                                </div>
                                                : ""
                                            }
                                            {po.Credits > 0 ?
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div className="label-price">
                                                        Credits
                                                        <div className="pull-right">
                                                            -${po.Credits}
                                                        </div>
                                                    </div>
                                                </div>
                                                : ""
                                            }

                                            {po.GST > 0 ?
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div className="label-price">
                                                        GST
                                                        <div className="pull-right">
                                                            ${po.GST}
                                                        </div>
                                                    </div>
                                                </div>
                                                : ""
                                            }

                                            {po.HST > 0 ?
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div className="label-price">
                                                        HST
                                                        <div className="pull-right">
                                                            ${po.HST}
                                                        </div>
                                                    </div>
                                                </div>
                                                : ""
                                            }

                                            {po.PST > 0 ?
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div className="label-price">
                                                        PST
                                                        <div className="pull-right">
                                                            ${po.PST}
                                                        </div>
                                                    </div>
                                                </div>
                                                : ""
                                            }


                                            {po.QST > 0 ?
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div className="label-price">
                                                        QST
                                                        <div className="pull-right">
                                                            ${po.QST}
                                                        </div>
                                                    </div>
                                                </div>
                                                : ""
                                            }

                                            {po.Total > 0 ?
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 clear-both">
                                                    <div className="label-price bigger">
                                                        <strong>
                                                            TOTAL
                                                            <div className="pull-right">
                                                                ${po.Total}
                                                            </div>
                                                        </strong>
                                                    </div>
                                                </div>
                                                : ""
                                            }
                                        </div>
                                    </div>
                                </CardSimple>
                            </div>
                        )
                        : null
                }

                <POPrintToPDF name="po-save" />

                {/*DIALOGS*/}
                <DialogInputNew
                    title="Create a New Vendor"
                    open={this.state.vendorDialogOpen}
                    autoScrollBodyContent={true}
                    className="checkIn_list"
                    handleClose={() => this.closeVendorForm()}
                    contentStyle={customContentStyle}>
                    <div className="no-crumb">
                        <VendorSave name="dialogVendor" isDialog={true} callListView={() => this.closeVendorForm()} />
                    </div>
                </DialogInputNew>
                <DialogInputNew
                    title="Create a New Product"
                    open={this.state.productDialogOpen}
                    autoScrollBodyContent={true}
                    className="transfer_Product checkIn_list memberDialogPOSScreen"
                    handleClose={() => this.closeProductForm()}
                    contentStyle={customContentStyle}>
                    <div className="no-crumb">
                        <ProductSave status="add" name="undefined" isDialog={true} closeDialog={() => this.closeProductForm()} />
                    </div>
                </DialogInputNew>
                <DialogInputNew
                    title="Remove Item"
                    handleClose={() => this.closeDialogRemoveProduct()}
                    actions={[
                        <Button
                            key={1}
                            name="buttonRemoveItem"
                            label="Confirm"
                            primary={true}
                            className="btnNewBrandPOS"
                            onTouchTap={() => this.deleteProduct()} />]}
                    open={this.state.removeProductDialogOpen}>
                    Are you sure that you want to remove this item from your Purchase Order?
                </DialogInputNew>
                <DialogInputNew
                    title="Un-Receive Item"
                    handleClose={() => this.closeDialogUnreceiveProduct()}
                    actions={[
                        <Button
                            key={2}
                            name="buttonRemoveItem"
                            label="Confirm"
                            className="btnNewBrandPOS"
                            primary={true}
                            onTouchTap={() => this.unreceiveProduct()} />]}
                    open={this.state.unreceiveProductDialogOpen}>
                    Are you sure you want to unreceive this item?
                </DialogInputNew>
                <DialogInputNew
                    title="Change Unit Price"
                    handleClose={() => this.closeDialogUpdateUnitPriceProduct()}
                    actions={[
                        <Button
                            key={2}
                            name="SaveButton"
                            label="Save"
                            primary={true}
                            className="btnNewBrandPOS mr-2"
                            onTouchTap={() => this.updateUnitPriceForProduct()} />]}
                    open={this.state.updateUnitPriceDialogOpen}>
                    <CardSimple style={{ width: '100%' }} className="p-1">
                        <div className="row">
                            <div className="col-lg-12">
                                <h3 className="m-0"><b>{this.state.productUnitPriceUpdate.product}</b></h3>
                                <p className="m-0 font-weight-normal">SKU: {this.state.productUnitPriceUpdate.sku}</p>
                                <p className="font-weight-normal">Category: {`[${this.state.productUnitPriceUpdate.type}] ${this.state.productUnitPriceUpdate.category}`} </p>
                                {
                                    this.state.productUnitPriceUpdate.packageReference && (
                                        <p className="font-weight-normal">Lot Number: {this.state.productUnitPriceUpdate.packageReference} </p>
                                    )
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <TextField name="UnitPriceInput"
                                    value={"$" + toMoney(this.state.unitPrice)}
                                    //value={Number(this.state.unitPrice).toFixed(2)}
                                    onChange={this.onChange} />
                                <br />Enter New Unit Price
                            </div>
                            <div className="col-lg-12">
                                <TextField name="NotesINput"
                                    value={this.state.productPriceUpdateNotes}
                                    onChange={this.onChangeNotes} />
                                <br />Notes
                            </div>
                        </div>
                    </CardSimple>
                </DialogInputNew>
                <DialogAlert open={false} message="" name="dialogStatusPO" onDialogClosed={() => this.statusDialogClosed()} />
                <DialogInputNew
                    title="Un-Receive All Items"
                    handleClose={() => this.closeUnreiveAllDialog()}
                    actions={[
                        <Button
                            key={2}
                            name="buttonRemoveItem"
                            label="Confirm"
                            className="btnNewBrandPOS"
                            primary={true}
                            onTouchTap={() => this.unreceiveAllProducts()} />]}
                    open={this.state.unreceiveAllProductsOpen}>
                    Are you sure you want to unreceive all products?
                </DialogInputNew>
            </Grid>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        purchaseOrderModel: selectPurchaseOrderModel(state, props.name),
        productsFromPO: state.entity.productListPO,
        vendors: state.entity.vendorList,
        vendor: state.form[props.name + "VendorID"],
        taxRates: state.entity.taxesrateList,
        updateStatusSuccess: state.form[props.name + "UpdateStatusSuccess"],
        saveSuccess: state.form[props.name + "SaveSuccess"],
        saveError: state.form[props.name + "SaveError"],
        branchId: state.common.branchId,
        subTotal: state.form[props.name + "POSubtotal"],
        total: state.form[props.name + "POTotal"],
        deliveryFee: state.form[props.name + "DeliveryFee"],
        recycleFee: state.form[props.name + "RecycleFee"],
        totalDepositAmount: state.form[props.name + "TotalDepositAmount"],
        GST: state.form[props.name + "GST"],
        HST: state.form[props.name + "HST"],
        PST: state.form[props.name + "PST"],
        newVendorId: state.form[props.name + "VendorID"] || null,
        store: state.common.store,
        productSaveSuccess: state.form[`ProductSaveSaveSuccess`] || null,
        unreceiveAllSuccess: state.entity.unreceiveAllSuccess,
        canChangePOStatus: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanChangePOStatus")),
        isHighTide: state.common.applicationSettings.isHighTide,
        isInspired: state.common.applicationSettings.isInspired,
        poSaveStatus: state.form[props.name + "Status"],
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        init: (name) => dispatch(initializePurchaseOrderForm(name)),
        getTaxesRate: (branchId) => dispatch(getTaxesRate(branchId)),
        savePurchaseOrder: (model) => dispatch(savePurchaseOrder(model, props.name)),
        getPurchaseOrder: (id, branchId) => dispatch(getPurchaseOrder(id, branchId, props.name)),
        removePOProduct: (index) => dispatch(removePOProduct(index)),
        getVendors: (country, provinceState) => dispatch(getVendorsByCountryState(country, provinceState)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        showErrorStatus: (message) => dispatch(showError(message, "dialogStatusPO")),
        cancelPurchaseOrder: (id, msg) => dispatch(cancelPurchaseOrder(id, msg, props.name)),
        openPurchaseOrder: (id, msg) => dispatch(openPurchaseOrder(id, msg, props.name)),
        onOrderPurchaseOrder: (id, msg) => dispatch(onOrderPurchaseOrder(id, msg, props.name)),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        updateUnitPriceDatabase: (model) => dispatch(updateUnitPriceDatabase(model)),
        unreceiveProduct: (model) => dispatch(unreceivePOProduct(model)),
        clearProductList: () => dispatch(clearProductList()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name)),
        unreceiveAll: (poId) => dispatch(unreceiveAll(poId))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(PurchaseOrderSave));
